import React from 'react'
import gql from 'graphql-tag'

import AgriculturalStudies from './AgriculturalStudies'
import GraphqlQuery from '../../molecules/GraphqlQuery'
import apolloClient from '../../../services/ApolloClient'

const STATE = gql`
  query AgriculturalStudiesContainer {
    themes(limit: 999, page: 1) {
      id
      name: nome
      url
    }

    research @client {
      collapses {
        isCollapse1Collapsed
        isCollapse2Collapsed
        isCollapse3Collapsed
        isCollapse4Collapsed
      }
      selectedTheme {
        id
        name
      }
    }
  }
`

export default class AgriculturalStudiesContainer extends React.Component {
  handleCollapseChange(stepNumber, newValue) {
    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          collapses: {
            __typename: 'ResearchCollapsesState',
            [`isCollapse${stepNumber}Collapsed`]: newValue
          }
        }
      }
    })
  }

  renderComponent = ({ research, themes }) => {
    let collapses = research.collapses

    return (
      <AgriculturalStudies
        isCollapse1Collapsed={ collapses.isCollapse1Collapsed }
        isCollapse2Collapsed={ collapses.isCollapse2Collapsed }
        isCollapse3Collapsed={ collapses.isCollapse3Collapsed }
        isCollapse4Collapsed={ collapses.isCollapse4Collapsed }
        onCollapse1Change={ () => { this.handleCollapseChange(1, !collapses.isCollapse1Collapsed) } }
        onCollapse2Change={ () => { this.handleCollapseChange(2, !collapses.isCollapse2Collapsed) } }
        onCollapse3Change={ () => { this.handleCollapseChange(3, !collapses.isCollapse3Collapsed) } }
        onCollapse4Change={ () => { this.handleCollapseChange(4, !collapses.isCollapse4Collapsed) } }
        selectedTheme={ research.selectedTheme }
        themes={ themes }
      />
    )
  }

  render() {
    return (
      <GraphqlQuery query={ STATE }>
        { this.renderComponent }
      </GraphqlQuery>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/AgriculturalStudies/AgriculturalStudies.container.js